<template>
  <div class="home-banner-wrap" v-if="bannersList">
    <slick ref="carousel" :options="slickOptions" v-if="bannersList.length">
      <div v-for="(sliderItem,key) in bannersList" :key="key">
        <div class="banner-slide">
          <router-link
            :to="{name: 'Products', query: {category: sliderItem.Category_Id, subcategory: sliderItem.Sub_Category}}"
          >
            <img :src="sliderItem.Image__1123x660" alt="slide-item" width="1123" height="660" />
          </router-link>
        </div>
      </div>
    </slick>
  </div>
</template>

<script>
import Slick from "vue-slick";
import { mapGetters } from "vuex";
export default {
  props: ["bannersList"],
  components: { Slick },
  computed: {
    ...mapGetters(["rtlLayout"]),
  },
  data() {
    return {
      slickOptions: {
        rtl: this.rtlLayout,
        slidesToShow: 1,
        infinite: true,
        swipe: true,
        autoplay: true,
        dots: false,
        arrows: false,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
            },
          },
        ],
      },
    };
  },
};
</script>

